import { RENT_FLOW_STEP_TYPE } from 'enums/rentFlowStepType';
import {
  RENT_PROGRESS_STATUS_PAGE_VIEWED,
  RENT_PROGRESS_STATUS_CONTRACT,
  RENT_PROGRESS_STATUS_CARD_OPENED,
} from '../constants';
import { fetchRentFlowsRequest } from '../Data/fetchRentFlowsRequest';

import {
  CONTRACT_HOUSE_FETCH_SUCCESS,
  CONTRACT_USER_FETCH_SUCCESS,
  FETCH_CONTRACTS_REQUEST,
  FETCH_RENT_FLOW_CONTRACTS,
  SHOULD_FETCH_CONTRACTS,
} from './constants';

export const fetchContractsRequest = ({
  userId,
  agentId,
  filters,
  lastItem,
  businessContext,
  currentPage,
  pageSize,
  pageBeginToken,
  pageEndToken,
}) => ({
  type: FETCH_CONTRACTS_REQUEST,
  payload: {
    userId,
    agentId,
    filters,
    lastItem,
    businessContext,
    currentPage,
    pageSize,
    pageBeginToken,
    pageEndToken,
  },
});

export const shouldFetchContracts = (status) => ({
  type: SHOULD_FETCH_CONTRACTS,
  payload: {
    status,
  },
});

export const contractHouseFetchSuccess = (payload) => ({
  type: CONTRACT_HOUSE_FETCH_SUCCESS,
  payload,
});

export const contractUserFetchSuccess = (payload) => ({
  type: CONTRACT_USER_FETCH_SUCCESS,
  payload,
});

export const fetchRentFlowContracts = ({
  startDate,
  endDate,
  daysAgo,
  currentPage,
  pageSize,
  pageBeginToken,
  pageEndToken,
}) => ({
  type: FETCH_RENT_FLOW_CONTRACTS,
  promise: fetchRentFlowsRequest({
    step: 'CONTRACT',
    startDate,
    endDate,
    daysAgo,
    currentPage,
    pageSize,
    pageBeginToken,
    pageEndToken,
    stepsWithMetadata: [
      RENT_FLOW_STEP_TYPE.DEMAND_CONTRACT_SIGNING,
      RENT_FLOW_STEP_TYPE.SUPPLY_CONTRACT_SIGNING,
    ],
  }),
});

export const triggerContractPageViewed = (urlOriginTrack) => ({
  type: RENT_PROGRESS_STATUS_PAGE_VIEWED,
  extraProperties: {
    rent_progress_status: RENT_PROGRESS_STATUS_CONTRACT,
    origin: urlOriginTrack,
  },
});

export const triggerContractStatusCardOpened = () => ({
  type: RENT_PROGRESS_STATUS_CARD_OPENED,
  extraProperties: {
    rent_progress_status: RENT_PROGRESS_STATUS_CONTRACT,
  },
});
